import { SparklesIcon } from '@heroicons/react/16/solid';
import ItemIcon from './../ItemIcon';
import { motion } from 'framer-motion';

const ButtonSuporte = () => {
	const item = {
		visible: { rotate: 0 },
		hidden: { rotate: 180 },
	};

	const scaleItem = {
		visible: { scale: 1.1 },
		hidden: {
			scale: 1,
		},
	};

	return (
		<ItemIcon>
			<div className="relative">
				<motion.div
					transition={{
						type: 'spring',
						bounce: 0.5,
					}}
					variants={item}
					className="absolute w-full h-full rounded-full"
					style={{ background: 'linear-gradient(180deg, #86DDFA 0%, #6B56A6 20.5%, #D97BF7 53%, #F0CF83 74%, #95F3DD 93%)' }}></motion.div>
				<div className="absolute z-[1] top-2/4 left-2/4 -translate-y-2/4 -translate-x-2/4 bg-white group-hover:bg-gray-100 h-[calc(100%-3px)] w-[calc(100%-3px)] rounded-full flex items-center justify-center">
					<motion.div
						transition={{
							type: 'spring',
							bounce: 0.5,
						}}
						variants={scaleItem}>
						<SparklesIcon width={10} height={10} />
					</motion.div>
				</div>
			</div>
		</ItemIcon>
	);
};

export default ButtonSuporte;
